// extracted by mini-css-extract-plugin
export default {"root":"NeovarsityManagementSubmittedPage_root__af0yn"};